import React from "react";

export default function PrivacyIndex() {
  return (
    <section className="my-8">
      <div className="container mx-auto bg-white p-4 md:p-8 shadow">
        <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
        <p>
          Privacy is one of the major concerns nowadays. This site does not
          require or collect any personal data like name email. This site is
          Client-side, it means when you create a receipt the data does not go
          to any server. It stays on your machine/system.
        </p>
        <h2 className="my-4 font-bold text-xl">
          Information Collection And Use
        </h2>
        <p className="mt-2">
          We use Google Analytics to track your Log Data. This Log Data may
          include information such as your computer's Internet Protocol ("IP")
          address, browser type, browser version, the pages of our Site that you
          visit, the time and date of your visit, the time spent on those pages
          and other statistics.
        </p>
        <h2 className="my-4 font-bold text-xl">
          Changes to this privacy policy
        </h2>
        <p>
          This Privacy Policy is effective as of (25-08-2020) and will remain in
          effect except concerning any changes in its provisions in the future,
          which will be in effect immediately after being posted on this page.
        </p>
        <p className="mt-3">
          We reserve the right to update or change our Privacy Policy at any
          time and you should check this Privacy Policy periodically. Your
          continued use of the Service after we post any modifications to the
          Privacy Policy on this page will constitute your acknowledgment of the
          modifications and your consent to abide and be bound by the modified
          Privacy Policy.
        </p>
        <h2 className="my-4 font-bold text-xl">Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact me
          at dipankarmaikap77@gmail.com.
        </p>
      </div>
    </section>
  );
}
